import React, {useCallback, useContext, useEffect, useMemo, useState} from 'react';
import {BaseStyle} from "../../../styles/shared/BaseStyle";
import HideAppBar from "../../widgets/header/HideAppBar";
import {
    Card,
    CardContent,
    CardHeader,
    Collapse,
    Container,
    Dialog,
    DialogContent,
    DialogTitle,
    FormControl,
    IconButton,
    Paper,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Tooltip,
    Typography
} from "@mui/material";
import Grid from "@mui/material/Grid";
import clsx from "clsx";
import {GestioneModuliStyle} from "../../../styles/pages/modules/GestioneModuliStyle";
import {useHistory} from "react-router-dom";
import * as MuiIcons from "@mui/icons-material";
import {Add, CloseRounded, Delete, ExpandLess, ExpandMore, NoteAdd, Save} from "@mui/icons-material";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import {getAllDynamicForm, updateDynamicCategories} from "../../../services/DynamicFormService";
import Autocomplete from '@mui/material/Autocomplete';
import {PaperComponent} from "../../../styles/components/DynamicComponentStyle";
import {DynamicIcon} from "../../../utils/dictionaries/Categories";
import {camelCaseToSentence} from "../../../utils/GenericUtils";
import {CategoriesContext} from "../../../App";


const initialData = {
    1: {
        label: "Informazioni generali",
        gruppo: "VACCINI",
        icon: "InfoTwoTone",
        color: "rgb(106,27,161)",
        colorTransparent: "rgba(108,15,185,0.5)",
        dynamicFormStructureId: 1,
        enabled: true,
        subCategories: [{label: "Altro", enabled: true, dynamicFormStructureId: 1}],
        links: [
            {url: "https://www.agenziaentrateriscossione.gov.it"}
        ],
    },
};

const GestioneCategorie = () => {
    const classes = BaseStyle();
    const history = useHistory();
    const categories = useContext(CategoriesContext);
    const moduliClasses = GestioneModuliStyle();
    const [data, setData] = useState([]);
    const [expanded, setExpanded] = useState({});
    const [dynamicForm, setDynamicForm] = useState([]);
    const [openDialog, setOpenDialog] = useState(false);


    useEffect(() => {
        setData(categories.categoriesV3)
    }, [categories]);

    useEffect(() => {
        getAllDynamicForm()
            .then(data => setDynamicForm(data || []))
            .catch(error => window.alert(error.message));
    }, []);

    const iconList = useMemo(() => {
        return Object.keys(MuiIcons)
            .filter((key) => key.endsWith("TwoTone"))
            .map((key) => ({label: key, key: key}));
    }, []);

    const pastelColors = useMemo(() => {
        return [
            {"hex": "#FFFFFF", "name": "Bianco (default)", "iconColor": "#00B19F"},
            {"hex": "#000000", "name": "Nero", "iconColor": "#FFFFFF"},
            {"hex": "#FF4D4D", "name": "Rosso Intenso", "iconColor": "#FFD700"},
            {"hex": "#FF7300", "name": "Arancione Vivo", "iconColor": "#32CD32"},
            {"hex": "#FFD700", "name": "Giallo Oro", "iconColor": "#8A2BE2"},
            {"hex": "#32CD32", "name": "Verde Brillante", "iconColor": "#FF1493"},
            {"hex": "#00CED1", "name": "Turchese", "iconColor": "#DC143C"},
            {"hex": "#1E90FF", "name": "Blu Elettrico", "iconColor": "#FF4500"},
            {"hex": "#9400D3", "name": "Viola Scuro", "iconColor": "#FFD700"},
            {"hex": "#FF1493", "name": "Rosa Vivo", "iconColor": "#228B22"},
            {"hex": "#FF4500", "name": "Rosso Arancio", "iconColor": "#4682B4"},
            {"hex": "#8B0000", "name": "Rosso Scuro", "iconColor": "#00CED1"},
            {"hex": "#DC143C", "name": "Cremisi", "iconColor": "#008080"},
            {"hex": "#B22222", "name": "Rosso Mattone", "iconColor": "#1E90FF"},
            {"hex": "#228B22", "name": "Verde Foresta", "iconColor": "#FF7300"},
            {"hex": "#006400", "name": "Verde Scuro", "iconColor": "#FF1493"},
            {"hex": "#556B2F", "name": "Verde Oliva Scuro", "iconColor": "#FFD700"},
            {"hex": "#008080", "name": "Teal", "iconColor": "#DC143C"},
            {"hex": "#4682B4", "name": "Blu Acciaio", "iconColor": "#FF4D4D"},
            {"hex": "#00008B", "name": "Blu Scuro", "iconColor": "#FF7300"},
            {"hex": "#483D8B", "name": "Blu Ardesia Scuro", "iconColor": "#FF1493"},
            {"hex": "#8A2BE2", "name": "Blu Viola", "iconColor": "#FFD700"},
            {"hex": "#9932CC", "name": "Viola Medio", "iconColor": "#32CD32"},
            {"hex": "#800080", "name": "Porpora", "iconColor": "#FFD700"},
            {"hex": "#C71585", "name": "Rosa Scuro", "iconColor": "#32CD32"}
        ].map((color, index) => ({
            label: color.name,
            key: color.hex,
            iconColor: color.iconColor
        }));
    }, []);


    const handleExpand = (id) => {
        setExpanded({...expanded, [id]: !expanded[id]});
    };

    const handleFieldChange = (id, field, value) => {
        setData({
            ...data,
            [id]: {
                ...data[id],
                [field]: value,
            },
        });
    };

    const handleColorFieldChange = (id, colorValue) => {
        setData({
            ...data,
            [id]: {
                ...data[id],
                color: colorValue,
                iconColor: pastelColors.filter(i => i.key === colorValue)[0].iconColor,
            },
        });
    };

    const handleToggleEnable = (id) => {
        setData({
            ...data,
            [id]: {
                ...data[id],
                enabled: !data[id].enabled,
            },
        });
    };

    const handleAddSubcategory = (id) => {
        setData({
            ...data,
            [id]: {
                ...data[id],
                subCategories: [
                    ...data[id].subCategories,
                    {label: "Nuova", enabled: true, dynamicFormStructureId: 1, isNew: true},
                ],
            },
        });
    };

    const handleRemoveSubcategory = (id, index) => {
        const newSubCategories = [...data[id].subCategories];
        newSubCategories.splice(index, 1);
        setData({
            ...data,
            [id]: {
                ...data[id],
                subCategories: newSubCategories,
            },
        });
    };

    const handleDisableSubcategory = (id, index) => {
        setData((prevData) => ({
            ...prevData,
            [id]: {
                ...prevData[id],
                subCategories: prevData[id].subCategories.map((subCategory, i) =>
                    i === index ? {...subCategory, enabled: !subCategory.enabled} : subCategory
                ),
            },
        }));
    };

    const handleAddCategory = () => {
        const nextId = Math.max(...Object.keys(data), 0) + 1;
        console.log(nextId)
        console.log(data)
        setData({
            ...data,
            [nextId]: {
                label: "Nuova Categoria",
                gruppo: "Nuovo Gruppo",
                icon: "Category",
                color: "#FFFFFF",
                iconColor: "#00B19F",
                colorTransparent: "rgba(0,0,0,0.5)",
                enabled: true,
                isNew: true,
                subCategories: [],
                links: [],
            },
        });
    };

    const handleRemoveLink = (id, index) => {
        const newLinks = [...data[id].links];
        newLinks.splice(index, 1);
        setData({
            ...data,
            [id]: {
                ...data[id],
                links: newLinks,
            },
        });
    };

    const handleAddLink = (id) => {
        setData({
            ...data,
            [id]: {
                ...data[id],
                links: [...data[id].links, {url: "https://nuovolink.com"}],
            },
        });
    };

    const handleChangeLink = (id, index, value) => {
        setData(prevData => ({
            ...prevData,
            [id]: {
                ...prevData[id],
                links: prevData[id]?.links?.map((link, i) =>
                    i === index ? {...link, url: value} : link
                ) || [],
            },
        }));
    };

    const handleChangeLinkLabel = (id, index, value) => {
        setData(prevData => ({
            ...prevData,
            [id]: {
                ...prevData[id],
                links: prevData[id]?.links?.map((link, i) =>
                    i === index ? {...link, label: value} : link
                ) || [],
            },
        }));
    };

    const handleSubFieldChange = (id, subIndex, field, value) => {
        setData((prevData) => ({
            ...prevData,
            [id]: {
                ...prevData[id],
                subCategories: prevData[id].subCategories.map((sub, index) =>
                    index === subIndex ? {...sub, [field]: value} : sub
                ),
            },
        }));
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleNewModulo = () => {
        history.push("/gestione/moduli/edit/" + 0, {config: []});
    };

    const handleSubmitChange = useCallback(() => {
        updateDynamicCategories(data)
            .then(data => {
                setData(data)
                categories.setCategoriesV3(data)
                setOpenDialog(true)
            })
            .catch(error => window.alert(error.message));
    }, [data,categories]);

    return (
        <React.Fragment>
            <main className={classes.main}>
                <HideAppBar title={"Gestione categorie"}/>
                <Container maxWidth={"xl"} component={"article"} style={{paddingTop: 12}}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Card className={clsx(classes.roundBorder)}
                                  style={{height: "100%", display: "flex", flexDirection: "column"}}>
                                <CardHeader
                                    title={<Typography variant={"h6"}><b>Categorie e Sotto Categorie
                                        disponibili</b></Typography>}
                                    subheader={"Qui sono elencate tutte le categorie e le relative sotto categorie disponibili, " +
                                        "qui è possibile gestire l'associazione di " +
                                        "un un modulo con una specifica categoria o sottocategoria. " +
                                        "Si ricorda di savare tramite apposito pulsante eventuali cambiamenti effettuati."}
                                />
                                <CardContent className={classes.flexCenter} style={{flexGrow: 1}}>
                                    <TableContainer component={Paper} className={classes.roundBorder}>
                                        <Table style={{tableLayout: "fixed", width: "100%"}}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell style={{
                                                        fontWeight: "bold"
                                                    }}>Nome</TableCell>
                                                    <TableCell style={{
                                                        fontWeight: "bold"
                                                    }} width={400}>Icona</TableCell>
                                                    <TableCell style={{
                                                        fontWeight: "bold"
                                                    }} width={400}>Form Dinamico</TableCell>
                                                    {/*<TableCell>Gruppo</TableCell>*/}
                                                    <TableCell style={{
                                                        fontWeight: "bold"
                                                    }}>Colore</TableCell>
                                                    <TableCell style={{
                                                        textAlign: "center",
                                                        fontWeight: "bold"
                                                    }} width={150}>Abilitazione</TableCell>
                                                    <TableCell style={{
                                                        fontWeight: "bold"
                                                    }} width={100}>Altro</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {Object.entries(data).map(([id, category]) => (
                                                    <React.Fragment key={id}>
                                                        <TableRow>
                                                            <TableCell>
                                                                {
                                                                    (category.isNew ? !category.isNew : true) ?
                                                                        (<Typography>
                                                                            {category.label}
                                                                        </Typography>) :
                                                                        (
                                                                            <TextField value={category.label}
                                                                                       onChange={(e) => handleFieldChange(id, "label", e.target.value)}
                                                                                       variant="outlined"
                                                                                       size="small"/>)
                                                                }

                                                            </TableCell>
                                                            {/*<TableCell>*/}
                                                            {/*    <TextField value={category.colorTransparent}*/}
                                                            {/*               onChange={(e) => handleFieldChange(id, "colorTransparent", e.target.value)}*/}
                                                            {/*               variant="outlined" size="small"/>*/}
                                                            {/*</TableCell>*/}
                                                            <TableCell>
                                                                <Box display='flex' flexDirection='row'
                                                                     alignItems='center' width='100%'>
                                                                    <Autocomplete
                                                                        style={{width: '100%', marginRight: 10}}
                                                                        options={iconList}
                                                                        getOptionLabel={(option) => camelCaseToSentence(option.label.replace("TwoTone", ""))}
                                                                        renderOption={(props) => {
                                                                            return (
                                                                                <div key={props.key} style={{
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                    gap: 8
                                                                                }}>
                                                                                    <DynamicIcon iconName={props.label}
                                                                                                 fontSize={20}
                                                                                                 color={category.iconColor}/> {camelCaseToSentence(props.label.replace("TwoTone", ""))}
                                                                                </div>
                                                                            );
                                                                        }}
                                                                        renderInput={(params) =>
                                                                            (<TextField {...params}
                                                                                        variant="outlined"
                                                                                        size="small" label="Icona"/>)}
                                                                        onChange={(event, newValue) => handleFieldChange(id, "icon", newValue?.key ?? '')}

                                                                        value={iconList.find((icon) => icon.label === category?.icon) || null}

                                                                        PaperComponent={PaperComponent}

                                                                    />
                                                                    <div style={{
                                                                        width: 50,
                                                                        height: 40,
                                                                        marginLeft: 10,
                                                                        backgroundColor: category.color + '7F',
                                                                        borderRadius: 4,
                                                                        border: "1px solid #ccc",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center"
                                                                    }}>
                                                                        <DynamicIcon
                                                                            key={category.iconColor}
                                                                            iconName={category.icon}
                                                                            fontSize={30}
                                                                            iconColor={category.iconColor}
                                                                        />
                                                                    </div>


                                                                </Box>


                                                            </TableCell>
                                                            <TableCell>
                                                                <Box display='flex' flexDirection='row'
                                                                     alignItems='center' width='100%'>
                                                                    <FormControl fullWidth>
                                                                        <Autocomplete
                                                                            size='small'
                                                                            options={Object.entries(dynamicForm).map(([key, value]) => ({
                                                                                key: value.id,
                                                                                label: value.label
                                                                            }))}

                                                                            value={Object.entries(dynamicForm)
                                                                                .map(([key, value]) => ({
                                                                                    key: value.id,
                                                                                    label: value.label
                                                                                }))
                                                                                .find(option => {
                                                                                    return option.key === category.dynamicFormStructureId;
                                                                                }) || null}
                                                                            getOptionLabel={(option) => option.label}
                                                                            isOptionEqualToValue={(option, value) => option.key === value.key}
                                                                            renderInput={(params) => (
                                                                                <TextField {...params}
                                                                                           label="Seleziona modulo"
                                                                                           variant="outlined"/>
                                                                            )}
                                                                            onChange={(event, newValue) => handleFieldChange(id, "dynamicFormStructureId", newValue?.key ?? '')}
                                                                            PaperComponent={PaperComponent}
                                                                        />
                                                                    </FormControl>
                                                                    <Tooltip
                                                                        style={{marginLeft: 5}}
                                                                        title={"Crea un nuovo modulo"}>
                                                                        <IconButton onClick={() => handleNewModulo()} size="large">
                                                                            <NoteAdd
                                                                                color='primary'/>
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </Box>
                                                            </TableCell>
                                                            {/*<TableCell>*/}
                                                            {/*    <TextField value={category.gruppo}*/}
                                                            {/*               onChange={(e) => handleFieldChange(id, "gruppo", e.target.value)}*/}
                                                            {/*               variant="outlined" size="small"/>*/}
                                                            {/*</TableCell>*/}
                                                            <TableCell>
                                                                <Box display='flex' flexDirection='row'
                                                                     alignItems='center' width='100%'>
                                                                    <FormControl fullWidth>
                                                                        <Autocomplete
                                                                            size='small'
                                                                            options={Object.entries(pastelColors).map(([key, value]) => ({
                                                                                key: value.key,
                                                                                label: value.label
                                                                            }))}

                                                                            value={Object.entries(pastelColors)
                                                                                .map(([key, value]) => ({
                                                                                    key: value.key,
                                                                                    label: value.label
                                                                                }))
                                                                                .find(option => {
                                                                                    return option.key === category.color;
                                                                                }) || null}
                                                                            getOptionLabel={(option) => option.label}
                                                                            isOptionEqualToValue={(option, value) => option.key === value.key}
                                                                            renderInput={(params) => (
                                                                                <TextField {...params}
                                                                                           label="Seleziona colore"
                                                                                           variant="outlined"/>
                                                                            )}
                                                                            renderOption={(props) => {
                                                                                return (
                                                                                    <div key={props.key} style={{
                                                                                        display: "flex",
                                                                                        alignItems: "center",
                                                                                        gap: 8
                                                                                    }}>
                                                                                        {/* Quadrato con il colore */}
                                                                                        <div style={{
                                                                                            width: 20,
                                                                                            height: 20,
                                                                                            backgroundColor: props.key,
                                                                                            borderRadius: 4,
                                                                                            border: "1px solid #ccc"
                                                                                        }}></div>

                                                                                        {/* Nome del colore */}
                                                                                        {props.label}
                                                                                    </div>
                                                                                );
                                                                            }}

                                                                            onChange={(event, newValue) => {
                                                                                handleColorFieldChange(id, newValue?.key ?? '');
                                                                            }}
                                                                            PaperComponent={PaperComponent}
                                                                        />
                                                                    </FormControl>
                                                                    <div style={{
                                                                        width: 30,
                                                                        height: 30,
                                                                        marginLeft: 10,
                                                                        backgroundColor: category.color,
                                                                        borderRadius: 4,
                                                                        border: "1px solid #ccc"
                                                                    }}></div>
                                                                </Box>
                                                            </TableCell>
                                                            <TableCell>

                                                                <Box display="flex" flexDirection="column"
                                                                     alignItems="center">
                                                                    {/* Switch sopra */}
                                                                    <Switch
                                                                        checked={category.enabled}
                                                                        color="primary"
                                                                        onChange={() => handleToggleEnable(id)}
                                                                    />

                                                                    {/* Label sotto con testo allineato */}
                                                                    <Box display="flex" justifyContent="space-evenly"
                                                                         width="100%">
                                                                        <Typography variant="body2"
                                                                                    color={!category.enabled ? 'textPrimary' : 'textSecondary'}>
                                                                            Nascondi
                                                                        </Typography>
                                                                        <Typography variant="body2"
                                                                                    color={category.enabled ? 'textPrimary' : 'textSecondary'}>
                                                                            Mostra
                                                                        </Typography>
                                                                    </Box>
                                                                </Box>
                                                            </TableCell>
                                                            <TableCell>
                                                                <IconButton onClick={() => handleExpand(id)} size="large">
                                                                    {expanded[id] ? <ExpandLess/> : <ExpandMore/>}
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>

                                                        <TableRow
                                                            style={{display: expanded[id] ? "table-row" : "none"}}
                                                        >
                                                            <TableCell colSpan={6}>
                                                                <Collapse in={expanded[id]} timeout="auto"
                                                                          unmountOnExit>
                                                                    <Box style={{width: "100%"}}>
                                                                        <Box display="flex" flexDirection="row"
                                                                             alignItems="center"
                                                                             justifyContent='center'>
                                                                            <Typography variant={"h6"}
                                                                                        style={{margin: 10}}><b>{"Sotto Categorie"}</b></Typography>
                                                                            <Tooltip
                                                                                classes={{tooltip: moduliClasses.tooltip}}
                                                                                title={"Clicca per aggiungere una sotto categoria"}>
                                                                                <Button
                                                                                    variant="contained"
                                                                                    disableElevation
                                                                                    size="small"
                                                                                    color="primary"
                                                                                    style={{
                                                                                        borderRadius: 24,
                                                                                        margin: 15,
                                                                                        display: "flex",
                                                                                        alignItems: "center",
                                                                                    }}
                                                                                    className={classes.roundButton}
                                                                                    onClick={() => handleAddSubcategory(id)}>

                                                                                    Crea Sotto Categoria
                                                                                    <Add style={{
                                                                                        verticalAlign: "middle",
                                                                                        marginLeft: 10
                                                                                    }}/>
                                                                                </Button>
                                                                            </Tooltip>
                                                                        </Box>
                                                                        <TableContainer component={Paper}
                                                                                        className={classes.roundBorder}>
                                                                            <Table style={{
                                                                                tableLayout: "fixed",
                                                                                width: "100%"
                                                                            }}>
                                                                                <TableHead>
                                                                                    <TableRow>
                                                                                        <TableCell style={{
                                                                                            width: "30%",
                                                                                            fontWeight: "bold"
                                                                                        }}>Nome
                                                                                            Sottocategoria</TableCell>
                                                                                        <TableCell style={{
                                                                                            width: "50%",
                                                                                            fontWeight: "bold"
                                                                                        }}>Seleziona Modulo</TableCell>
                                                                                        <TableCell style={{
                                                                                            width: "10%",
                                                                                            textAlign: "center",
                                                                                            fontWeight: "bold"
                                                                                        }}>Abilitazione</TableCell>
                                                                                        <TableCell style={{
                                                                                            width: "10%",
                                                                                            textAlign: "center",
                                                                                            fontWeight: "bold"
                                                                                        }}>Azioni</TableCell>
                                                                                    </TableRow>
                                                                                </TableHead>
                                                                                <TableBody>
                                                                                    {category.subCategories.map((sub, index) => (
                                                                                        <TableRow key={index}>
                                                                                            <TableCell>
                                                                                                {(sub.isNew ? !sub.isNew : true) ? (
                                                                                                    <Typography>{sub.label}</Typography>
                                                                                                ) : (
                                                                                                    <TextField
                                                                                                        value={sub.label}
                                                                                                        onChange={(e) => handleSubFieldChange(id, index, "label", e.target.value)}
                                                                                                        variant="outlined"
                                                                                                        size="small"
                                                                                                        fullWidth
                                                                                                    />
                                                                                                )}
                                                                                            </TableCell>
                                                                                            <TableCell>
                                                                                                <Box display='flex'
                                                                                                     flexDirection='row'
                                                                                                     alignItems='center'
                                                                                                     width='100%'>
                                                                                                    <FormControl
                                                                                                        fullWidth>
                                                                                                        <Autocomplete
                                                                                                            size="small"
                                                                                                            options={Object.entries(dynamicForm).map(([key, value]) => ({
                                                                                                                key: value.id,
                                                                                                                label: value.label
                                                                                                            }))}
                                                                                                            value={Object.entries(dynamicForm)
                                                                                                                .map(([key, value]) => ({
                                                                                                                    key: value.id,
                                                                                                                    label: value.label
                                                                                                                }))
                                                                                                                .find(option => option.key === sub.dynamicFormStructureId) || null}
                                                                                                            getOptionLabel={(option) => option.label}
                                                                                                            renderInput={(params) => (
                                                                                                                <TextField {...params}
                                                                                                                           label="Seleziona modulo"
                                                                                                                           variant="outlined"/>
                                                                                                            )}
                                                                                                            onChange={(event, newValue) =>
                                                                                                                handleSubFieldChange(id, index, "dynamicFormStructureId", newValue?.key ?? '')
                                                                                                            }
                                                                                                        />
                                                                                                    </FormControl>
                                                                                                    <Tooltip
                                                                                                        style={{marginLeft: 5}}
                                                                                                        title={"Crea un nuovo modulo"}>
                                                                                                        <IconButton onClick={() => handleNewModulo()} size="large">
                                                                                                            <NoteAdd
                                                                                                                color='primary'/>
                                                                                                        </IconButton>
                                                                                                    </Tooltip>
                                                                                                </Box>
                                                                                            </TableCell>
                                                                                            <TableCell>
                                                                                                <Box display="flex"
                                                                                                     flexDirection="column"
                                                                                                     alignItems="center">
                                                                                                    {/* Switch sopra */}
                                                                                                    <Switch
                                                                                                        checked={sub.enabled}
                                                                                                        color="primary"
                                                                                                        onClick={() => handleDisableSubcategory(id, index)}
                                                                                                    />

                                                                                                    {/* Label sotto con testo allineato */}
                                                                                                    <Box display="flex"
                                                                                                         justifyContent="space-evenly"
                                                                                                         width="100%">
                                                                                                        <Typography
                                                                                                            variant="body2"
                                                                                                            color={!sub.enabled ? 'textPrimary' : 'textSecondary'}>
                                                                                                            Nascondi
                                                                                                        </Typography>
                                                                                                        <Typography
                                                                                                            variant="body2"
                                                                                                            color={sub.enabled ? 'textPrimary' : 'textSecondary'}>
                                                                                                            Mostra
                                                                                                        </Typography>
                                                                                                    </Box>
                                                                                                </Box>
                                                                                            </TableCell>
                                                                                            <TableCell align="center">
                                                                                                <IconButton
                                                                                                    disabled={sub.isNew ? !sub.isNew : true}
                                                                                                    onClick={() => handleRemoveSubcategory(id, index)}
                                                                                                    size="large">
                                                                                                    <Delete
                                                                                                        style={{color: (sub.isNew ? !sub.isNew : true) ? 'grey' : 'red'}}/>
                                                                                                </IconButton>
                                                                                            </TableCell>
                                                                                        </TableRow>
                                                                                    ))}
                                                                                </TableBody>
                                                                            </Table>
                                                                        </TableContainer>

                                                                        <Box display="flex" flexDirection="row"
                                                                             alignItems="center"
                                                                             justifyContent='center'>
                                                                            <Typography variant={"h6"}
                                                                                        style={{margin: 10}}><b>{"Link"}</b></Typography>
                                                                            <Tooltip
                                                                                classes={{tooltip: moduliClasses.tooltip}}
                                                                                title={"Clicca per aggiungere un link"}>
                                                                                <Tooltip
                                                                                    classes={{tooltip: moduliClasses.tooltip}}
                                                                                    title={"Clicca per aggiungere una sotto categoria"}>
                                                                                    <Button
                                                                                        variant="contained"
                                                                                        disableElevation
                                                                                        size="small"
                                                                                        color="primary"
                                                                                        style={{
                                                                                            borderRadius: 24,
                                                                                            margin: 15,
                                                                                            display: "flex",
                                                                                            alignItems: "center",
                                                                                        }}
                                                                                        className={classes.roundButton}
                                                                                        onClick={() => handleAddLink(id)}>

                                                                                        Aggiungi Link
                                                                                        <Add style={{
                                                                                            verticalAlign: "middle",
                                                                                            marginLeft: 10
                                                                                        }}/>
                                                                                    </Button>
                                                                                </Tooltip>
                                                                            </Tooltip>
                                                                        </Box>
                                                                        <TableContainer component={Paper}
                                                                                        className={classes.roundBorder}>
                                                                            <Table style={{
                                                                                tableLayout: "fixed",
                                                                                width: "100%"
                                                                            }}>
                                                                                <TableHead>
                                                                                    <TableRow>

                                                                                        <TableCell
                                                                                            style={{
                                                                                                width: "30%",
                                                                                                fontWeight: "bold"
                                                                                            }}>Label</TableCell>
                                                                                        <TableCell
                                                                                            style={{
                                                                                                width: "50%",
                                                                                                fontWeight: "bold"
                                                                                            }}>URL</TableCell>
                                                                                        <TableCell
                                                                                            style={{
                                                                                                width: "10%",
                                                                                                fontWeight: "bold"
                                                                                            }}>Azioni</TableCell>
                                                                                    </TableRow>
                                                                                </TableHead>
                                                                                <TableBody>
                                                                                    {category.links.map((link, index) => (
                                                                                        <TableRow key={index}>
                                                                                            <TableCell>
                                                                                                <TextField
                                                                                                    value={link.label}
                                                                                                    variant="outlined"
                                                                                                    size="small"
                                                                                                    fullWidth
                                                                                                    onChange={(e) => handleChangeLinkLabel(id, index, e.target.value)}
                                                                                                />
                                                                                            </TableCell>
                                                                                            <TableCell>
                                                                                                <TextField
                                                                                                    value={link.url}
                                                                                                    variant="outlined"
                                                                                                    size="small"
                                                                                                    fullWidth
                                                                                                    onChange={(e) => handleChangeLink(id, index, e.target.value)}
                                                                                                />
                                                                                            </TableCell>
                                                                                            <TableCell>
                                                                                                <IconButton
                                                                                                    size='small'
                                                                                                    onClick={() => handleRemoveLink(id, index)}
                                                                                                    edge="end">
                                                                                                    <Delete
                                                                                                        style={{color: 'red'}}/>
                                                                                                </IconButton>
                                                                                            </TableCell>
                                                                                        </TableRow>
                                                                                    ))}
                                                                                </TableBody>
                                                                            </Table>
                                                                        </TableContainer>
                                                                    </Box>
                                                                </Collapse>
                                                            </TableCell>
                                                        </TableRow>

                                                    </React.Fragment>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <Button
                                        variant="contained"
                                        disableElevation
                                        size="small"
                                        color="primary"
                                        style={{
                                            borderRadius: 24,
                                            margin: 15,
                                            display: "flex",
                                            alignItems: "center",
                                        }}
                                        className={classes.roundButton}
                                        onClick={handleAddCategory}
                                    >
                                        Crea Categoria
                                        <Add style={{verticalAlign: "middle", marginLeft: 10}}/>
                                    </Button>


                                    <Button
                                        variant="contained"
                                        disableElevation
                                        size="small"
                                        color="primary"
                                        style={{
                                            borderRadius: 24,
                                            margin: 15,
                                            display: "flex",
                                            alignItems: "center",
                                        }}
                                        className={classes.roundButton}
                                        onClick={() => handleSubmitChange()}>
                                        Salva le modifiche
                                        <Save style={{verticalAlign: "middle", marginLeft: 10}}/>

                                    </Button>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                    {/* Dialog per conferma salvataggio */}
                    <Dialog open={openDialog}
                            onClose={handleCloseDialog}
                            maxWidth="md" fullWidth PaperProps={{
                        className: clsx(classes.roundBorder, classes.shadow24)
                    }}>
                        <DialogTitle>
                            <Typography><b>Esito salvataggio</b></Typography>
                            <IconButton
                                aria-label="close"
                                onClick={handleCloseDialog}
                                style={{position: "absolute", right: 8, top: 8}}
                                size="large">
                                <CloseRounded/>
                            </IconButton>
                        </DialogTitle>
                        <DialogContent>
                            <Typography style={{marginTop: 0, marginRight: 20, marginBottom: 20, marginLeft: 0}}
                            > Dati salvati correttamente </Typography>
                        </DialogContent>
                    </Dialog>
                </Container>
            </main>
        </React.Fragment>
    );
};

export default React.memo(GestioneCategorie);
